<template>
   <v-container>
        <div class="text-left" style="margin-bottom:20px;">
            <router-link to="/uk">
                <v-btn
                    color="secondary"
                    class="text-right"
                    style="width:250px"
                >
                    Back
                </v-btn>
            </router-link>
        </div>           
      <v-row>
        <v-col cols="12" class="text-left">
          <h1>February 10</h1>
          <div class="text-left">
            <p>Golden Circle</p>
            <a href="/uk/10GoldenCircle.jpeg"><img alt="RAF Museum Duxford" class="uitk-image-media" src="/uk/10GoldenCircle.jpeg" style="width: 17%; height: auto;"></a>
            <p>In London</p>
            <a href="/uk/10London.jpeg"><img alt="London" class="uitk-image-media" src="/uk/10London.jpeg" style="width: 17%; height: auto;"></a>
            <a href="/uk/10London2.jpeg"><img alt="London" class="uitk-image-media" src="/uk/10London2.jpeg" style="width: 17%; height: auto;"></a>
            <p>T-Shirt Options James</p>
            <a href="/uk/10LondonShirts1.jpeg"><img alt="London T-Shirt Options" class="uitk-image-media" src="/uk/10LondonShirts1.jpeg" style="width: 17%; height: auto;"></a>
            <a href="/uk/10LondonShirts2.jpeg"><img alt="London T-Shirt Options" class="uitk-image-media" src="/uk/10LondonShirts2.jpeg" style="width: 17%; height: auto;"></a>
            <a href="/uk/10LondonShirts3.jpeg"><img alt="London T-Shirt Options" class="uitk-image-media" src="/uk/10LondonShirts3.jpeg" style="width: 17%; height: auto;"></a>
            <p>Moulin Rouge</p>
            <a href="/uk/10MoulinRouge.jpeg"><img alt="MoulinRouge" class="uitk-image-media" src="/uk/10MoulinRouge.jpeg" style="width: 17%; height: auto;"></a>
          </div>      
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
      ////
    }
  }
  </script>